import { render, staticRenderFns } from "./CartNotice.vue?vue&type=template&id=a4a071b0"
import script from "./CartNotice.vue?vue&type=script&lang=js"
export * from "./CartNotice.vue?vue&type=script&lang=js"
import style0 from "./CartNotice.vue?vue&type=style&index=0&id=a4a071b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports